import { useEnvStore } from '@gik/core/store/EnvStore';

export const initialGreetingCard = useEnvStore.getState().INITIAL_GREETING_CARD;

export const anonymousName = 'Anonymous';
